<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CardPopupImg
        :isModalVisible="modal.LKI01"
        :cardContentFlower="Flwimage"
        :cardContent="content"
        :CheckWidth="CheckWidth"
        :cardType="type"
        :openModal="openModal"
        :score="scoreTest"
      />
      <CardPopupInfoTranparent
        :isAddQueueShow="modal.LKA01"
        :cardContent="FlwData"
        :cardContentPaht="content"
        :CheckWidth="CheckWidth"
        :cardType="type"
        @updateUser="funcRoute"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CardPopupImg from "../../components/template/Chinese1/CardPopupImg";
import CardPopupInfoTranparent from "../../components/template/Chinese1/CardpopupInfoTranparent";
import "../../assets/scss/_chineseStyle.scss";
import "../../assets/scss/_chineseIcon.scss";
import "../../assets/scss/_chineseModalCustom.scss";
import LoadingMDL from "../../components/loading/LoadingMDL";

export default {
  components: { CardPopupImg, CardPopupInfoTranparent, LoadingMDL },
  name: "LKA01",
  data() {
    return {
      CheckWidth: window.innerWidth.toString(),
      code: "",
      lang: "",
      content: {},
      Flwimage: "",
      FlwData: {},
      modal: {
        LKI01: true,
        LKA01: false,
      },
      score: 0,
      type: "flower",
      baseUrl: process.env.VUE_APP_URL_SOUND,
      MaxScore: [],
      MinimumScore: [],
      LessonID: 0,
      mode: {},
      assignmentTestScore: {},
      scoreTest: this.$store.getters[`necessary/getLKAScore`],
      courseSection: "",
      startTime: "",
      courseCode: "",
      condition: [],
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      allCourse: "template/getTemplateContent",
      assignmentTest: "template/getAssignmentTest",
      getUserTemplate: "template/getUserTemplate",
    }),
  },

  watch: {
    allCourse: function(val) {
      if (!val.enable) {
        alert("Access denied!");
        this.$router.push({ name: val.navigate.close.action });
      } else {
        this.content = val;
        this.checkScore(this.content);
        this.courseSection = this.$store.getters['necessary/getUserCourseSection']
        this.$store.dispatch("template/createUserTemplateData", {
          code: this.courseCode,
          template: val._id,
          section: this.courseSection,
        });
      }
    },
    assignmentTest: function(val) {
      this.assignmentTestScore = val;
      if (this.mode.assingmentmode == true) {
        this.score = this.assignmentTestScore.userscore;
      } else if (this.mode.posttestMode == true) {
        alert("posttestMode");
      } else if (this.mode.pretestMode == true) {
        alert("pretestMode");
      } else if (this.mode.testmode == true) {
        this.score = this.assignmentTestScore.userscore;
      } else {
        this.score = this.$store.getters["score/getPoint"];
      }
    },
    getUserTemplate: function(val) {
      this.condition =
        typeof val.data.condition.criteriaType == "undefined" ||
        val.data.condition.criteriaType.length == 0
          ? []
          : [
              {
                criteria: val.data.condition.criteriaType[0].criteria._id,
                val: val.data.condition.criteriaType[0].val,
              },
            ];
      this.loading = false;
    },
  },

  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = `LKA01-` + this.$route.params.id;
    this.$store.dispatch("template/fetchContent", body);
    this.lang = this.$store.state.language.language;
  },
  created() {
    this.startTime = this.$helpers.getDateFormat();
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
  },
  beforeDestroy() {},
  methods: {
    checkWidth() {
      if (this.CheckWidth > 800) {
        return "container-chinese-card";
      } else if (this.CheckWidth <= 800) {
        return "container-chinese-card-mobile";
      }
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    openModal() {
      this.modal = {
        LKI01: false,
        LKA01: true,
      };
    },
    checkScore(data) {
      var Question = data.content.question;
      for (let i = 0; i < Question.length; i++) {
        this.MaxScore.push(Question[i].item[0].data);
        this.MinimumScore.push(Question[i].item[0].data++ + 1);
      }
      if (
        this.scoreTest >= this.MinimumScore[1] &&
        this.scoreTest <= this.MaxScore[2]
      ) {
        this.Flwimage = data.content.question[2].item[2].data;
        this.FlwData = data.content.question[2];
      } else if (
        this.scoreTest >= this.MinimumScore[0] &&
        this.scoreTest <= this.MaxScore[1]
      ) {
        this.Flwimage = data.content.question[1].item[2].data;
        this.FlwData = data.content.question[1];
      } else if (this.scoreTest >= 0 && this.scoreTest <= this.MaxScore[0]) {
        this.Flwimage = data.content.question[0].item[2].data;
        this.FlwData = data.content.question[0];
      } else if (this.scoreTest) {
        this.Flwimage = data.content.question[0].item[2].data;
        this.FlwData = data.content.question[0];
      } else {
        alert("Score Error!");
      }
    },
    funcRoute() {
      this.$store.dispatch("template/saveUserTemplateData", {
        code: this.courseCode,
        template: this.content._id,
        section: this.courseSection,
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
      });
    },
  },
};
</script>
<style></style>
